export default "__VITE_ASSET__BKRIFhy___"